module.exports = __webpack_public_path__ + "static/media/img-hero-meet.8c284740.png";